import { Permission } from '@cims-online/shared'
import CIMSCollapse from 'components/CIMSCollapse'
import CIMSSection from 'components/CIMSSection'
import Panel from './components/Panel'
import { useDevelopersModuleContext } from '../../../../DevelopersModuleContext'

const Permissions: React.VFC = () => {
  const { users, loading } = useDevelopersModuleContext()
  return (
    <CIMSSection
      loading={loading}
      title="Developer Permissions"
      help="Specific developer permissions and users with them"
    >
      <CIMSCollapse
        panels={Permission.developers.map((permission) => {
          const u2dpCount = users.filter(({ userToDeveloperPermissions }) =>
            userToDeveloperPermissions.some(
              ({ permissionId }) => permissionId === permission.id
            )
          ).length
          const devCount = users.filter(({ developer }) => developer).length
          return {
            header: permission.fullName,
            key: permission.id,
            children: <Panel permission={permission} />,
            forceRender: true,
            extra: {
              type: 'counts',
              counts: [
                {
                  key: permission.id + '-additionals',
                  count: u2dpCount,
                  showZero: false,
                  children: `User${u2dpCount === 1 ? '' : 's'}`,
                },
                {
                  key: permission.id + '-developers',
                  count: devCount,
                  children: `Developer${devCount === 1 ? '' : 's'}`,
                  backgroundColor: '#808080',
                  showZero: false,
                },
              ],
            },
          }
        })}
      />
    </CIMSSection>
  )
}

export default Permissions
